import { Avatar as AvatarComponent } from 'base/ui/avatar';
import { TextTiny } from 'base/ui/typography';
import { UserAvatar } from 'blocks/blocks_service';
import classNames from 'classnames';
import React from 'react';
import styles from './avatars.css';

export function Avatars({
  avatars,
  max,
  isUnread,
}: {
  avatars: readonly UserAvatar[];
  max: number;
  isUnread?: boolean;
}) {
  const show =
    avatars.length > max
      ? avatars.slice(0, max - 1).reverse()
      : [...avatars].reverse();
  const numHidden = Math.min(avatars.length - show.length, 9);

  return (
    <div className={styles.avatars}>
      {numHidden > 0 && (
        <div
          className={classNames(styles.avatar, styles.isOverflow)}
          style={{
            ['--avatarX' as string]: show.length,
          }}
        >
          <TextTiny>+{numHidden}</TextTiny>
        </div>
      )}
      {show.map((avatar, i) => (
        <div
          key={i}
          style={{ ['--avatarX' as string]: show.length - i - 1 }}
          className={styles.avatar}
        >
          <AvatarComponent size="medium" bordered={false} {...avatar} />
        </div>
      ))}
      {isUnread && (
        <div
          className={styles.unreadIndicator}
          style={{ ['--avatarX' as string]: show.length }}
        />
      )}
    </div>
  );
}
